import React from 'react';
import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_name',
    title: 'Middle initial',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const exemptionQuestionsFromData = [
  {
    id: 'exemption_reason',
    title: 'Select an exemption status.',
    question_type: 'long_multiple_choice',
    is_required: true,
    options: [
      {
        codeValue: 'ri_withholding',
        shortName: 'Select this option if you meet both of these conditions to claim exemption from Rhode Island withholding:\n'
          + 'a) Last year you had a right to a refund of all Rhode Island income tax withheld because you had no tax liability AND\n\n'
          + 'b) This year you expect a refund of all Rhode Island income tax because you expect to have no tax liability.',
      },
      {
        codeValue: 'military_spouse',
        shortName: 'Select this option if you are the spouse of a servicemember stationed in Rhode Island, your wages may be exempt under the Military Spouses\n\n'
          + ' Residency Relief Act. If you meet both of these conditions, you may claim exemption from Rhode Island withholding:\n\n'
          + 'a) You moved to Rhode Island solely to be with your servicemember spouse in compliance with military orders sending the servicemember to Rhode Island AND\n\n'
          + 'b) You have the same non-Rhode Island domicile as your servicemember spouse.',
      },
    ],
  },
];

export const allowanceAndAdditionalAmtQuestions = [
  {
    id: 'total_num_allowances',
    title: (
      <div>
        Enter the number of allowances from
        {' '}
        <a href="https://check-api-static-production.s3.amazonaws.com/forms/pdf/ri_w4_05.pdf" target="_blank" rel="noopener noreferrer">
          line 1E
        </a>
        {' '}
        (Line 1)
      </div>
    ),
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Enter any additional dollar amount which you would like withheld from your pay. (Line 2)',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const personalAllowancesQuestion = [
  {
    id: 'claim_dependents',
    title: 'Allowance(s) for your dependents, not including yourself or your spouse',
    question_type: 'long_multiple_selection',
    is_required: false,
    options: [
      {
        codeValue: 'cannot_be_claimed_dependent',
        shortName: 'Check this box if no one else can claim you as a dependent. (1A)',
      },
      {
        codeValue: 'claim_spouse_dependent',
        shortName: 'Check this box if you can claim your spouse as a dependent. (1B)',
      },
    ],
  },
];

export const worksheetQuestions = [
  {
    id: 'num_dependents',
    title: 'Enter the number of dependents (other than you or your spouse) you will claim on your tax return. (1C)',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_allowances',
    title: 'Enter any additional allowances (review carefully to avoid underwithholding). (1D)',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Enter any additional dollar amount which you would like withheld from your pay. (Line 2)',
    question_type: 'short_text',
    is_required: false,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];
